/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const NatObj = require('../types/NatObj')
const CElementBase = require('./CElementBase')
const Color = require('../types/Color')
const Fonte = require('../types/Fonte')
const kernel = require('../kernel/kernel')
module.exports = CElementGraphique
/**
 * @constructor
 * @extends CElementBase
 * Objet ancêtre de tous les objets graphiques.
 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet
 * @param {CImplementationProto} impProto : null ou pointe sur la construction propriétaire de l'objet
 * @param {Boolean} estElementFinal : true si l'objet est un objet inal de construction
 * @param {Color} couleur : La couleur de l'objet
 * @param {Boolean} nomMasque : true si le nom de l'objet est masqué
 * @param {Integer} dec_x : Le décalage horizontal du nom
 * @param {Integer} dec_y : Le décalage vertical du nom
 * @param {Boolean} masque : true si l'objet est masque
 * @param {String} nom : le nom éventuel de l'objet
 * @param {Integer} tailleNom : l'indice donnant la taille du nom
 * @returns {undefined}
 */
function CElementGraphique (listeProprietaire, impProto, estElementFinal, couleur, nomMasque,
  dec_x, dec_y, masque, nom, tailleNom) {
  if (arguments.length === 0) return; // Ajout version 4.9.9.4 pour constructeur
  if (arguments.length === 1) {
    CElementBase.call(this, listeProprietaire);
    this.nom = ""; // Sert pour le protocole de la figure
  }
  else {
    CElementBase.call(this, listeProprietaire, impProto, estElementFinal);
    this.couleur = couleur;
    this.nomMasque = nomMasque;
    this.dec_x = dec_x;
    this.dec_y = dec_y;
    this.masque = masque;
    this.nom = nom;
    this.tailleNom = tailleNom;
    // Rajout version 4.9.9.4
    if (couleur !== null) this.color = couleur.rgb(); // Certains objets inclus dans d'autres
    // peuvent ne pas avoir de couleur quand ils sont créés.
  }
  this.id = ""; // Spécial JavaScript
  this.g = null; // Idem
  this.gname = null;
  // Ajout version 5.0.4 :Sert pour les objets dupliqués de CLatex
  this.hasDuplicate = false;
}
CElementGraphique.prototype = new CElementBase();
CElementGraphique.prototype.constructor = CElementGraphique;
CElementGraphique.prototype.superClass = "CElementBase";
CElementGraphique.prototype.className = "CElementGraphique";

/**
 * Fonction renvoyant un clode de l'objet
 * @returns {CElementGraphique}
 */
CElementGraphique.prototype.creeClone = function() {
  return this.getClone(this.listeProprietaire, this.listeProprietaire);
};
/**
 * Fonction faisant de this un objet de mêmes caractéristiques que ptel
 * ptel doit être un élément du même type que this
 * @param {CElementBase} ptel
 * @returns {undefined}
 */
CElementGraphique.prototype.setClone = function(ptel) {
  CElementBase.prototype.setClone.call(this, ptel);
  this.x_nom = ptel.x_nom;
  this.y_nom = ptel.y_nom;
  this.dec_x = ptel.dec_x;
  this.dec_y = ptel.dec_y;
  this.masque = ptel.masque;
};

/**
 * Ajout version 5.2 (numéro de version 16). Renverra true si l'objet possède un nom qui doit être enregistré dans le flux
 * @returns {boolean}
 */
CElementGraphique.prototype.hasName = function() {
  return false;
}

/**
 * Ajout version 5.2 (numéro de version 16). Renverra true si l'objet possède deux éléments dec_x et dec_y doit être enregistré dans le flux
 * Sera redéfini à true dans CAffLiePt
 * @returns
 */
CElementGraphique.prototype.hasDec = function() {
  return this.hasName();
}


/**
 * Fonction rendant l'objet masqué
 * @returns {undefined}
 */
CElementGraphique.prototype.cache = function() {
  this.masque = true;
};
/**
 * Fonction rendant l'objet visible
 * @returns {undefined}
 */
CElementGraphique.prototype.montre = function() {
  this.masque = false;
};
/**
 * Fonction donnant à l'objet le nom nomInit
 * @param {String} nomInit
 * @returns {undefined}
 */
CElementGraphique.prototype.donneNom = function(nomInit) {
  this.nom = nomInit;
};
/**
 * Renvoei le nom de l'objet
 * @returns {String}
 */
CElementGraphique.prototype.rendNom = function() {
  return this.nom;
};
/**
 * Fonction plaçant le point ux coordonnées (x,y)
 * @param {Number} xn
 * @param {Number} yn
 * @returns {undefined}
 */
CElementGraphique.prototype.placeNom = function(xn, yn) {
  this.x_nom = xn;
  this.y_nom = yn;
};
/**
 * Decale le nom de l'objet de (dec_xn, dec_yn)
 * @param {Integer} dec_xn
 * @param {Integer} dec_yn
 * @returns {undefined}
 */
CElementGraphique.prototype.decaleNom = function(dec_xn, dec_yn) {
  this.dec_x = dec_xn;
  this.dec_y = dec_yn;
};
// A revoir svg
/**
 * Fonction créant un élément svg représentant le nom de l'objet
* @returns {SVGTextElement}
 */
CElementGraphique.prototype.createName = function() {
  var nom = this.nom;
  var taille = this.tailleNom; // Modifié version 5.0
  var y = this.y_nom + this.dec_y + taille
  var text = kernel.cens("text",{
    x : this.x_nom + this.dec_x,
    y : y,
    style : "text-anchor : left;"+"fill:"+this.couleur.rgb()+";"+"font-size:"+taille+"px;",
    id : this.id+"name",
    "pointer-events" : "none" // Ne marche pas avec chrome
  });
  // disableSelection(text);
  // On recherche un éventuel indice
  for (var i = 0; i < nom.length; i++) {
    if (Fonte.chiffre(nom.charAt(i))) break;
  }
  var deb = nom.substring(0, i);
  var span1 = kernel.cens("tspan");
  var cont1 = document.createTextNode(deb);
  span1.appendChild(cont1);
  text.appendChild(span1);
  if (i < nom.length) {
    var fin = nom.substring(i);
    var span2 = kernel.cens("tspan",{
      "font-size" : Math.floor(taille*2/3)+"pt;",
      dy : Math.floor(taille/3)
  });
    var cont2 = document.createTextNode(fin);
    span2.appendChild(cont2);
    text.appendChild(span2);
  }
  // Ajout version mtgApp car la version mtgApp a besoin de connaître les dimensions d'affichage du nom
  if (this.createNameAdd) this.createNameAdd(text);
  //
  return text;
};
/**
 * Fonction ajoutant au svg svg le texte element représentant le nom de l'objet
 * @param {svg} svg
 * @returns {undefined}
 */
CElementGraphique.prototype.afficheNom = function(svg) {
  this.gname = this.createName();
  svg.appendChild(this.gname);
};

CElementGraphique.prototype.updateNamePosition = function() {
  this.gname.setAttribute("x", this.x_nom + this.dec_x);
  this.gname.setAttribute("y", this.y_nom + this.dec_y + this.tailleNom);
  // Les lignes suivantes ne concernent que la version mtgApp
  if (this.rectName) {
    var bb = this.gname.getBBox();
    this.rectName.x = bb.x;
    this.rectName.y = bb.y;
    this.rectName.width = bb.width;
    this.rectName.height = bb.height;
  }
}

/**
 * Fonction mettant à jour le sgv text element représentant le nom de l'objet
 * @param {svg} svg
 * @param {Boolean} masquage
 * @returns {undefined}
 */
CElementGraphique.prototype.updateName = function(svg, masquage) {
  if (this.nom === "") {
    if (this.gname !== null) {
      svg.removeChild(this.gname);
      this.gname = null;
    }
  }
  else {
    var gn = this.createName();
    if (this.gname !== null) {
      try {
        svg.replaceChild(gn, this.gname);
      }
      catch (e) { // Rajouté suite à rapport BusNag
        this.g.parentNode.insertBefore(gn, this.g.nextSibling);
      }
    }
    else {
      // Ne pas utiliser ici kernelAdd qui utilise jquery alors que le player ne l'utilise pas
      // kernelAdd.insertAfter(gn, this.g)
      this.g.parentNode.insertBefore(gn, this.g.nextSibling);
    }
    this.gname = gn;
    if (this.masque || (masquage && this.nomMasque)) this.gname.setAttribute("visibility", "hidden");
  }

  /*
  var oldgname = this.gname;
  var newgname = this.createName();
  svg.replaceChild(newgname, oldgname);
  this.gname = newgname;
  */
  /**
 * Ne marche pas pour une raison que j'ignore. Après le premier affichage, le suivant se décale
  var taille = Fonte.taille(this.tailleNom);
  g.removeAttribute("x");
  g.removeAttribute("y");
  g.setAttribute("x", this.x);
  g.setAttribute("y", this.y + this.dec_y + taille);
  */
};
/**
 * Fonction donnant la couleur coul à l'objet
 * @param {Color} coul
 * @returns {undefined}
 */
CElementGraphique.prototype.donneCouleur = function(coul) {
  this.couleur = coul;
  this.color = coul.rgb(); // Ajout version 4.9.9.5
};
/**
 * Fonction renvoyant la distance entre this et le point de coordonnnées (xp,yp).
 * Si masquage est à true, renvoie la distance même si le point est masqué.
 * A redéfinir pour les descendants
 * @param {Number} xp
 * @param {Number} yp
 * @param {Boolean} masquage
 * @returns {Number}
 */
CElementGraphique.prototype.distancePoint = function(xp, yp, masquage) {
  return -1;
};
/**
 * Fonction renvoyant la distance entre this et le point de coordonnnées (xp,yp)
 * pour les objest de type surface.
 * Si masquage est à true, renvoie la distance même si le point est masqué.
 * A redéfinir pour les descendants
 * @param {Number} xp
 * @param {Number} yp
 * @param {Boolean} masquage
 * @returns {Number}
 */

CElementGraphique.prototype.distancePointPourSurface = function(xp, yp, masquage) {
  return -1;
};
/**
 * Fonction renvoyant, pour un point lié à un objet, l'abscisse maximale relative à cet objet
 * @returns {Number}
 */
CElementGraphique.prototype.abscisseMaximale = function() {
  return 1;
};
/**
 * Fonction renvoyant, pour un point lié à un objet, l'abscisse minimale relative à cet objet
 * @returns {Number}
 */
CElementGraphique.prototype.abscisseMinimale = function() {
  return 0;
};
/**
 * Fonction ajoutant à svg le svg element représentant l'objet (via trace())
 * et donnant à cet élément l'attribut visible ou masqué suivant que
 * l'objet est masqué ou non
 * @param {svg} svg : Le svg dans lequel est tracée la figure
 * @param {Boolean} masquage : true si on cache les objets cachés
 * @param {Color} couleurFond
 * @param {Number} transparence : la transparence de l'ojet (pour les surfaces)
 * @returns {undefined}
 */
CElementGraphique.prototype.affiche = function(svg, masquage, couleurFond, transparence) {
  this.trace(svg, couleurFond, transparence);
  if ((this.g !== null) && masquage && this.masque) this.g.setAttribute("visibility", "hidden");
};
/**
 * Spécial JavaScript : Renverra true si l'objet est bien représenté graphiquement dans le svg
 * Si le deuxième paramètre est à true, renvoie true même si l'objet est masqué
 * @param {Boolean} masquage : true si les obejts masqués ne sont pas affichés
 * @param {Boolean} memeMasque : CF ci-dessus
 * @returns {Boolean}
 */
CElementGraphique.prototype.hasg = function(masquage, memeMasque = false) {
  return this.existe && (memeMasque || !(this.masque && masquage));
};
/**
 * Fonction qui renverra true si l'objet exsite mas est hors fenêtre.
 * Rajouté par rapport à la version Java car un objet dupliqué a besoin de savoir
 * si l'élément qu'il duplique est ou non représenté dans le DOM par un sgv element.
 * Utilisé dans cObjetDuplique
 * @returns {Boolean}
 */
CElementGraphique.prototype.horsCadre = function() {
  return false;
};
/**
 * Fonction recréant le svg element représentant l'objet et remplaçant dans le svg
 * svg l'ancien élément par le nouveau.
 * Spécial JavaScript : A redéfinir pour les éléments dont il faut recalculer
 * le svg élément quand ils sont dépacés ou modifiés.
 * @param {svg} svg
 * @returns {undefined}
 */
CElementGraphique.prototype.update = function(svg) {
};
/**
 * Fonction à redéfinir pour CPt (CPointAncetre en java)
 * Sert pour le tracé des points marqués pour la trace.
 * @param {svg} svg
 * @returns {undefined}
 */
CElementGraphique.prototype.updateTrace = function(svg) {
};
/**
 * Fonction renvoyant true si l'objet est à l'intérieur de la fenêtre définie par dimfen
 * @param Dimf dimfen
 * @returns {Boolean}
 */
CElementGraphique.prototype.dansFen = function(dimfen) {
  return true;
};
/**
 * Fonction renvoyant le nombre d'objets pour un lieu d'objets
 * Redéfinit pour ls lieux de lieux
 * @returns {Number}
 */
CElementGraphique.prototype.nombreObjetsPourLieuObjet = function() {
  return 1;
};

CElementGraphique.prototype.read = function(inps, list) {
  CElementBase.prototype.read.call(this, inps, list);
  this.masque = inps.readBoolean();
  var r = inps.readByte();
  var g = inps.readByte();
  var b = inps.readByte();
  this.couleur = new Color(r, g, b);
  // Rajout version 4.9.9.4
  this.color = this.couleur.rgb();
  //
  if (this.hasName() || (list.numeroVersion < 16)) {

    this.nomMasque = inps.readBoolean();
    this.tailleNom = inps.readByte();
    // Modification version 5.0 : taillePolice est maintenant la taille réelle de la police
    if (list.numeroVersion < 15) this.tailleNom = Fonte.taille(this.tailleNom);
    // Correction de figures qui ont été mal renregistrées
    this.nom = inps.readUTF();
  }
  if (this.hasDec() || (list.numeroVersion < 16)) {
    if (this.listeProprietaire.numeroVersion < 11) {
      this.dec_x = inps.readDouble();
      this.dec_y = inps.readDouble();
    }
    else {
      var by = inps.readByte();
      if (by === 1) {
        this.dec_x = 0;
        this.dec_y = 0;
      }
      else {
        this.dec_x = inps.readDouble();
        this.dec_y = inps.readDouble();
      }
    }
  }
};

CElementGraphique.prototype.write = function(oups, list){
  CElementBase.prototype.write.call(this, oups, list);
  oups.writeBoolean(this.masque);
  oups.writeByte(this.couleur.getRed());
  oups.writeByte(this.couleur.getGreen());
  oups.writeByte(this.couleur.getBlue());
  if (this.hasName()) {
    oups.writeBoolean(this.nomMasque);
    oups.writeByte(this.tailleNom);
    oups.writeUTF(this.nom);
  }
  if (this.hasDec()) {
    if ((this.dec_x === 0) && (this.dec_y === 0)) oups.writeByte(1);
    else {
      oups.writeByte(0);
      oups.writeDouble(this.dec_x);
      oups.writeDouble(this.dec_y);
    }
  }
};
/**
 * Spécial version mtgApp : Crée l'élement associé à l'objet dans le DOM
 * @param svg
 * @param masquage
 * @param couleurFond
 * @param transparence
 */
CElementGraphique.prototype.creeAffichage = function(svg,masquage,couleurFond,transparence) {
  if (this.hasg(masquage)) {
    this.affiche(svg, masquage, couleurFond, transparence);
    this.hasgElement = true;
    if (this.estDeNature(NatObj.NObjNommable) && (this.nom !== "")
      && !this.nomMasque) this.afficheNom(svg);
    this.updateTrace(svg, couleurFond, transparence); // Pour les points marqués pour la trace
  }
  else {
    var newg = kernel.cens("g",{
      id : this.id
    }); // Un g vide
    svg.appendChild(newg);
    this.g = newg;
    this.hasgElement = false;
    if (this.estDeNature(NatObj.NObjNommable) && (this.nom !== "")
      && !this.nomMasque) {
      var gname = kernel.cens("g"); // Un g vide
      this.gname = gname;
      svg.appendChild(gname);
    }
  }
};


/**
 * Fonction détruisant l'élément el et retirant son composant graphique s'il existe
 * @param svg : Le svg de la figure
 */
CElementGraphique.prototype.removegElement = function(svg) {
  if (this.g !== null) svg.removeChild(this.g);
  if (this.gname !== null) svg.removeChild(this.gname);
}
